$(document).ready(function () {
  document.querySelectorAll('.image-text-panels').forEach((container) => {
    const swiperEl = container.querySelector('.image-text-panels-items.swiper-container');
    if (swiperEl) {
      new Swiper(swiperEl, {
        slidesPerView: 1.05,
        spaceBetween: 24,
        pagination: {
          el: container.querySelector('.swiper-pagination'),
          clickable: true,
        },
        scrollbar: {
          el: container.querySelector('.swiper-scrollbar'),
          draggable: true,
        },
        breakpoints: {
          480: {
            slidesPerView: 1,
            spaceBetween: 24,
          },
          768: {
            slidesPerView: 1,
            spaceBetween: 24,
            enabled: true,
          },
          990: {
            enabled: false,
          },
          0: {
            enabled: true,
          }
        }
      });
    }
  });
});